import { memo } from "react";
import { FormattedMessage } from "react-intl";

import Link from "common/core/link";
import Row from "common/details/grid/row";

type Notary = {
  email: string | null;
  id: string;
};

type Props = {
  notary: Notary;
};

function AgentGid({ notary }: Props) {
  return (
    <Row
      title={
        <FormattedMessage id="04fe601c-f868-4955-9589-da47a26fac8b" defaultMessage="Notary GID" />
      }
    >
      <div className="DetailGrid-data--heading">
        <Link to={`/notary?email=${encodeURIComponent(notary.email!)}`}>{notary.id}</Link>
      </div>
    </Row>
  );
}

export default memo(AgentGid);
